import React from 'react'


import PantryHero from './PantryHero'
import PantryContent from './PantryContent'
import PantryServices from './PantryServices'
import PantryTrustSection from './PantryTrustsection'
import PantryTransform from './PantryTransform'
import Footer from '../../Footer/Footer'

function PantryCorporate() {
    return (
        <div>
            <PantryHero/>
            <PantryContent/>
            <PantryServices/>
            <PantryTrustSection/>
            <PantryTransform/>
            <Footer/>
            
        </div>
    )
}

export default PantryCorporate
